import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BrandLogoActions } from "@youm-front/brand/data-access";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomBrandLogoActions } from "../actions";
import {
  RoomBrandLogoCreateRequestDTO,
  RoomBrandLogoDeleteRequestDTO,
  RoomBrandLogoUnUseRequestDTO,
  RoomBrandLogoUseRequestDTO
} from "../dto";
import { RoomBrandLogoService } from "../services";

@Injectable()
export class RoomBrandLogoEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomBrandLogoService: RoomBrandLogoService
  ) {}

  roomBrandLogoCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandLogoActions.roomBrandLogoCreate),
      switchMap((_) =>
        this.roomBrandLogoService
          .roomBrandLogoCreate(
            new RoomBrandLogoCreateRequestDTO({
              roomId: _.roomBrandLogoCreateVO.value.roomId,
              brandId: _.roomBrandLogoCreateVO.value.brandId,
              data: _.roomBrandLogoCreateVO.value.data,
              width: _.roomBrandLogoCreateVO.value.width,
              height: _.roomBrandLogoCreateVO.value.height
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandLogoActions.roomBrandLogoCreateSuccess({
                brandLogo: _.data.brandLogo
              }),
              BrandLogoActions.brandLogoCreateSuccess({
                brandLogo: _.data.brandLogo
              })
            ]),
            catchError((_: Error) => [
              RoomBrandLogoActions.roomBrandLogoCreateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandLogoDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandLogoActions.roomBrandLogoDelete),
      switchMap((_) =>
        this.roomBrandLogoService
          .roomBrandLogoDelete(
            new RoomBrandLogoDeleteRequestDTO({
              roomId: _.roomBrandLogoDeleteVO.value.roomId,
              brandLogo: _.roomBrandLogoDeleteVO.value.brandLogo
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandLogoActions.roomBrandLogoDeleteSuccess({
                brandLogo: _.data.brandLogo
              }),
              BrandLogoActions.brandLogoDeleteSuccess({
                brandLogo: _.data.brandLogo
              })
            ]),
            catchError((_: Error) => [
              RoomBrandLogoActions.roomBrandLogoDeleteFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandLogoUnUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandLogoActions.roomBrandLogoUnUse),
      switchMap((_) =>
        this.roomBrandLogoService
          .roomBrandLogoUnUse(
            new RoomBrandLogoUnUseRequestDTO({
              roomId: _.roomBrandLogoUnUseVO.value.roomId,
              brandLogo: _.roomBrandLogoUnUseVO.value.brandLogo
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandLogoActions.roomBrandLogoUnUseSuccess({
                brandLogo: _.roomBrandLogoUnUseVO.value.brandLogo
              }),
              BrandLogoActions.brandLogoUnUseSuccess({
                brandLogo: _.roomBrandLogoUnUseVO.value.brandLogo
              })
            ]),
            catchError((_: Error) => [
              RoomBrandLogoActions.roomBrandLogoUnUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandLogoUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandLogoActions.roomBrandLogoUse),
      switchMap((_) =>
        this.roomBrandLogoService
          .roomBrandLogoUse(
            new RoomBrandLogoUseRequestDTO({
              roomId: _.roomBrandLogoUseVO.value.roomId,
              brandLogo: _.roomBrandLogoUseVO.value.brandLogo
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandLogoActions.roomBrandLogoUseSuccess({
                brandLogo: _.roomBrandLogoUseVO.value.brandLogo
              }),
              BrandLogoActions.brandLogoUseSuccess({
                brandLogo: _.roomBrandLogoUseVO.value.brandLogo
              })
            ]),
            catchError((_: Error) => [
              RoomBrandLogoActions.roomBrandLogoUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );
}
